export const contracts = {
	solicitation: {
		columns: {
			id: "Id del Ticket",
			requestBy: "Nombre del solicitante",
			requestDate: "Fecha de la solicitud",
			requestReason: "Motivo de la solicitud",
			requestType: "Tipo de solicitud",
			returnDate: "Fecha de retorno",
			status: "Estado",
		},
		filter: {
			periodTimeLabel: "Fecha de la solicitud",
			statusLabel: "Estado",
			statusPlaceholder: "Seleccione el estado de la solicitud",
		},
		incident: "Incidente",
		status: {
			closed: "Finalizado",
			hold: "En espera",
			open: "Abierto",
			new: "Nuevo",
			pending: "Pendiente",
			solved: "Resuelto",
		},
		title: "Solicitudes",
	},
	history: {
		title: "Historial de contratos",
		filename: "historial_de_contratos",
		status: {
			approved: "Aprobado",
			pendingApproval: "Aprobación pendiente",
			pendingSign: "Firma pendiente",
		},
		columns: {
			requestDate: "Fecha de la solicitud",
			signatureDate: "Fecha de la firma",
			contract: "Contrato",
			managerName: "Responsable comercial",
			signedBy: "Responsable de la firma",
			status: "Estado",
		},
		filter: {
			periodTimeLabel: "Fecha de la solicitud",
			statusLabel: "Estado",
			statusPlaceholder: "Seleccione el estado de la solicitud",
		},
		details: {
			title: "Solicitud hecha en el modelo",
			temporary: "temporal",
			permanent: "permanente",
			contractNotFound: "Contrato no encontrado",
			equipaments: {
				equipament: "Equipo",
				quantity: "Cantidad",
				unitValue: "Valor unitario",
				totalValue: "Valor Total",
			},
			manager: {
				managerName: "Responsable ZIG",
				managerContact: "Canal de contacto",
			},
			file: {
				type: "Tipo de solicitud",
				requestModel: "Modelo de solicitud",
				contractPeriod: "Tiempo del contrato",
			},
		},
		actionsTable: {
			details: "Ver detalles de la solicitud",
			downloadDocuments: "Descargar documentos",
		},
	},
};
